export default __webpack_public_path__ + "static/media/MucLogoCircle.7aa820b9.svg";